import { createContext, useState, useEffect } from "react";
import axios from "axios";

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = async (inputs) => {
    try {
      const res = await axios.post("/api/auth/login", inputs, { withCredentials: true });
      localStorage.setItem("hasSession", "1");
      setCurrentUser(res.data);
    } catch (err) {
      throw err;
    }
  };

  const logout = async () => {
    try {
      await axios.post("/api/auth/logout", {}, { withCredentials: true });
      localStorage.removeItem("hasSession");
      setCurrentUser(null);
    } catch (err) {}
  };

  const updateProfilePicture = (newImageUrl) => {
    setCurrentUser((prevUser) => {
      if (!prevUser) return prevUser;
      return { ...prevUser, img: newImageUrl };
    });
  };

  const refreshAccessToken = async () => {
    try {
      await axios.get("/api/auth/refresh/token/new", { withCredentials: true });
    } catch {
      logout();
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      const hasSession = localStorage.getItem("hasSession");
      if (!hasSession) {
        setLoading(false);
        return;
      }

      try {
        const res = await axios.get("/api/auth/me", { withCredentials: true });
        setCurrentUser(res.data);
      } catch (err) {
        if (err.response?.status === 401 || err.response?.status === 403) {
          localStorage.removeItem("hasSession");
        }
        setCurrentUser(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  useEffect(() => {
    if (!currentUser) return;

    const interval = setInterval(() => {
      refreshAccessToken();
    }, 45 * 60 * 1000); // svakih 45 minuta

    return () => clearInterval(interval);
  }, [currentUser]);

  return (
    <AuthContext.Provider
      value={{ currentUser, setCurrentUser, login, logout, loading, updateProfilePicture }}
    >
      {children}
    </AuthContext.Provider>
  );
};
